import styles from "./OverviewSubTab.module.scss"

import type { BankAccountType } from "@/company_admin/gql/__generated__/graphql"
import { useBankLookup } from "@/company_admin/hooks/useBankLookup"

const BANK_ACCOUNT_TYPE_LABELS: Record<BankAccountType, string> = {
	ORDINARY: "普通",
	CHECKING: "当座",
}

type Props = {
	bankCode: string
	bankBranchCode: string
	bankAccountType: BankAccountType
	bankAccountNumber: string
	bankAccountHolderName: string
}

const BankInfoSection = ({
	bankCode,
	bankBranchCode,
	bankAccountType,
	bankAccountNumber,
	bankAccountHolderName,
}: Props) => {
	const { bankName, branchName } = useBankLookup(bankCode, bankBranchCode)

	return (
		<div className={styles.section}>
			<h3 className={styles.section_title}>口座情報</h3>
			<dl className={styles.info_list}>
				<div className={styles.info_item}>
					<dt className={styles.info_label}>銀行名</dt>
					<dd className={styles.info_value}>
						{bankName
							? `${bankName} (${bankCode})`
							: `（銀行コード: ${bankCode}）`}
					</dd>
				</div>
				<div className={styles.info_item}>
					<dt className={styles.info_label}>支店名</dt>
					<dd className={styles.info_value}>
						{branchName
							? `${branchName} (${bankBranchCode})`
							: `（支店コード: ${bankBranchCode}）`}
					</dd>
				</div>
				<div className={styles.info_item}>
					<dt className={styles.info_label}>口座種別</dt>
					<dd className={styles.info_value}>
						{BANK_ACCOUNT_TYPE_LABELS[bankAccountType]}
					</dd>
				</div>
				<div className={styles.info_item}>
					<dt className={styles.info_label}>口座番号</dt>
					<dd className={styles.info_value}>{bankAccountNumber}</dd>
				</div>
				<div className={styles.info_item}>
					<dt className={styles.info_label}>口座名義</dt>
					<dd className={styles.info_value}>{bankAccountHolderName}</dd>
				</div>
			</dl>
		</div>
	)
}

export default BankInfoSection
